/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AddressInfoTS = {
  type: 'AddressInfo',
} as const;
